<div class="modal-header">
    <span>{{ modalHeader }}</span>
    <button
        class="close"
        aria-label="Close"
        (click)="closeModal(false)"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    L'utente ha ricevuto informazioni riguardo l'applicazione hAppyMamma
    <label class="custom-control custom-radio">
        <input
            type="radio"
            class="custom-control-input"
            name="info_app"
            [(ngModel)]="info_app"
            [value]="true"
        >
        <span class="custom-control-indicator"></span>
        <span class="custom-control-description">Sì</span>
    </label>
    <label class="custom-control custom-radio">
        <input
            type="radio"
            class="custom-control-input"
            checked
            [(ngModel)]="info_app"
            name="info_app"
            [value]="false"
        >
        <span class="custom-control-indicator"></span>
        <span class="custom-control-description">No</span>
    </label>
</div>
<div class="modal-footer">
    <button
        *ngIf="modalCancelEnabled"
        nbButton
        status="danger"
        (click)="closeModal(false)"
    >{{modalCancelText}}</button>
    <button
        nbButton
        (click)="closeModal(true)"
    >{{modalOkText}}</button>
</div>
